import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

type TabKey = 'active' | 'draft';

type VoteTabsProps = {
  value?: TabKey;
  onChange?: (key: TabKey) => void;
  className?: string;
};

const TabsBar = styled.div`
  // width: 100%;  
  padding: 10px 10px;
  display: flex;
  align-items: center;
  gap: clamp(24px, 6vw, 56px);
  margin-bottom: ${window.innerWidth > 768 ? "" : "1.5rem"};
`;

const TabItem = styled.button<{ $active?: boolean }>`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;  
  font-size: clamp(15px, 3.6vw, 15px);
  // font-size: 15px;
  letter-spacing: 0.02em;
  color: ${(p) => (p.$active ? '#FFFFFF' : 'rgba(255,255,255,0.6)')};
  position: relative;
  outline: none;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -10px;
    height: 4px;
    width: ${(p) => (p.$active ? '100%' : '0%')};
    background: #6A29DD;
    border-radius: 2px;
    transition: width 200ms ease;
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(106, 41, 221, 0.4);
    border-radius: 6px;
  }
`;

const tabs = [
  { key: 'active' as TabKey, label: 'Active Votes' },
  { key: 'draft' as TabKey, label: 'Draft Votes' },  
];

function VoteTabs({ value, onChange, className }: VoteTabsProps) {
  const [active, setActive] = useState<TabKey>(value ?? 'active');

  // Sync controlled value
  useEffect(() => {
    if (value) setActive(value);
  }, [value]);

  const handleSelect = (key: TabKey) => {
    if (!value) setActive(key);
    onChange?.(key);
  };

  const renderedTabs = useMemo(
    () =>
      tabs.map((t) => (
        <TabItem key={t.key} $active={active === t.key} onClick={() => handleSelect(t.key)}>
          {t.label}
        </TabItem>
      )),
    [active]
  );

  return (
  <>
  <TabsBar className={className}>{renderedTabs}
  </TabsBar>  
  </>

  );
}

export default VoteTabs;
